import Vue from 'vue';
import Router from 'vue-router';
import Hello from '@/components/Hello';
import lst2asm from '@/components/lst2asm';
import hex2asm from '@/components/hex2asm';
import hex2bin from '@/components/hex2bin';
import bin2asm from '@/components/bin2asm';
import sna2bas from '@/components/sna2bas';
import bitswap from '@/components/bitswap';
import z2i from '@/components/z2i';
import i2z from '@/components/i2z';
import sound from '@/components/sound';
import mathtable from '@/components/mathtable';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/lst2asm',
      name: 'LST2ASM',
      component: lst2asm
    },
    {
      path: '/hex2asm',
      name: 'hex2ASM',
      component: hex2asm
    },
    {
      path: '/hex2bin',
      name: 'hex2bin',
      component: hex2bin
    },
    {
      path: '/bin2asm',
      name: 'bin2ASM',
      component: bin2asm
    },
    {
      path: '/sna2bas',
      name: 'sna2bas',
      component: sna2bas
    },
    {
      path: '/bitswap',
      name: 'bitswap',
      component: bitswap
    },
    {
      path: '/z2i',
      name: 'z2i',
      component: z2i
    },
    {
      path: '/i2z',
      name: 'i2z',
      component: i2z
    },
    {
      path: '/sound',
      name: 'sound',
      component: sound
    },
    {
      path: '/math',
      name: 'mathtable',
      component: mathtable
    }
  ]
});
